'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var OlatheStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('on-scene', Q('geo:arrived'))
	.add('work completed', Q('geo:departed', 'geo:location_skipped'))
	.add('team done', Q('team:done'))
	.add('awaiting approval', Q('form_skipped'));


export default function(incident) {
	OlatheStateDiagram.updateIncident(incident);
	incident.phoneFromUrl =  reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	switch (incident.version) {
		case 'olathe_sewer_a':
		case 'olathe_water_a':
			incident.teamDesignations = ['On-call B', 'On-call C'];
		case 'olathe_sewer_b':
		case 'olathe_water_b':
			incident.teamDesignations = ['On-call A', 'On-call C'];
		case 'olathe_sewer_c':
		case 'olathe_water_c':
			incident.teamDesignations = ['On-call A', 'On-call B'];
		case 'olathe_sewer_generic':
		case 'olathe_water_generic':
			incident.teamDesignations = ['On-call A', 'On-call B', 'On-call C'];
	}
}
